import * as request from 'services/request'
import { notification as notify } from 'utils'
import * as util from 'pages/widgets/util'
import * as mapping from 'pages/widgets/mapping'
import validate from 'pages/widgets/validation'
import { destroy } from 'redux-form'

const { startWidget } = util
const { formToWidget, widgetToForm } = mapping

export const actionTypes = {
  RECEIVED_WIDGET: 'RECEIVED_WIDGET'
}

const removeForm = form => destroy(form)

export const receivedWidget = widget => ({
  type: actionTypes.RECEIVED_WIDGET,
  payload: widgetToForm(widget)
})

export const getWidget = id => async dispatch => {
  try {
    dispatch(removeForm('widget'))
    const response = await request.authorized(`/widgets/${id}`)
    const widget = await response.json()

    if (!widget.widgetData.startDate || !widget.widgetData.endDate) {
      notify.warning({
        message: `Experience '${widget.widgetData.name}' does not have a start and end date. Dates have been defaulted to current date.`
      })
    }

    dispatch(receivedWidget(widget))
  } catch (e) {
    console.error(e)
  }
}

export const updateWidget = id => dispatch => saveAndStart => async formValues => {
  try {
    const { name, uniqueCodes, uniqueCodesFileName } = formValues

    try {
      const widget = formToWidget(formValues)

      if (validate({ ownerId: widget.ownerId, values: widget.widgetData })) {
        return
      }

      await request.authorized(`/widgets/${id}`, {
        method: 'PUT',
        body: widget
      })

      if (uniqueCodes && uniqueCodes.length > 0 && uniqueCodesFileName) {
        await request.authorized(`/unique-code-lists`, {
          method: 'POST',
          body: {
            uniqueCodes,
            name: uniqueCodesFileName,
            widgetId: id
          }
        })
      }

      const response = await request.authorized(`/widgets/${id}`)

      const updatedWidget = await response.json()
      dispatch(receivedWidget(updatedWidget))

      notify.success({
        message: `Experience '${name}' saved successfully!`
      })

      if (saveAndStart) {
        await startWidget(updatedWidget)
      }
    } catch (e) {
      util.notifyError(e, name)
    }
  } catch (e) {
    console.error(e)
  }
}



// WEBPACK FOOTER //
// ./src/pages/widgets/form-actions/edit/actions.js